import React from 'react';
import styles from './SectionHeader.module.css';

/**
 * Reusable section header with label, title, and optional description.
 */
function SectionHeader({ label, title, desc, center = false }) {
  const cls = [styles.header, center ? styles.center : ''].join(' ').trim();
  return (
    <div className={cls}>
      {label && <div className={styles.label}>{label}</div>}
      {title && (
        <h2
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      {desc && (
        <p
          className={styles.desc}
          dangerouslySetInnerHTML={{ __html: desc }}
        />
      )}
    </div>
  );
}

export default SectionHeader;
